const de = {
  'language.flag': '🇩🇪',
  'language.name': 'Deutsch',
  'navigation.home': 'Startseite',
  'navigation.language': 'Sprache',
  'navigation.openMenu': 'Menü öffnen',
  'navigation.closeMenu': 'Menü schließen',
  'navigation.skipToContent': 'Zum Inhalt springen',
  'categories.sightseeing.name': 'Sehenswürdigkeiten',
  'categories.sightseeing.heading': 'Die beliebtesten Sehenswürdigkeiten in Augsburg',
  'categories.sightseeing.lead': 'Vom UNESCO-Welterbe bis zur Fuggerei: Augsburg hat mehr zu bieten, als du denkst.',
  'categories.events.name': 'Veranstaltungen',
  'categories.events.heading': 'Alle Veranstaltungen auf einen Blick',
  'categories.events.lead': 'Finde heraus, welche Konzerte, Märkte und Stadtführungen diese Woche in Augsburg stattfinden.',
  'categories.blog.name': 'Aktuelles',
  'categories.blog.heading': 'Neues aus Augsburg',
  'categories.blog.lead': 'Hintergründe, Stadtgeschichte und aktuelle Themen zum Lesen und Weitererzählen.',
  'categories.emptyTitle': 'Noch nichts hier',
  'categories.emptyDescription': 'In diesem Bereich gibt es noch keine Seiten. Schau bald wieder vorbei.',
  'home.title': 'Willkommen in Augsburg',
  'home.intro': 'Ob Städtetrip, Geschäftsreise oder Familienbesuch. Hier findest du alle wichtigen Informationen für deine Zeit in Augsburg.',
  'home.sightseeing.eyebrow': 'UNESCO-Welterbe-Stadt',
  'home.sightseeing.title': 'Sehenswürdigkeiten entdecken',
  'home.sightseeing.lead': 'Vom UNESCO-Welterbe bis zur Fuggerei: Augsburg hat mehr zu bieten, als du denkst.',
  'home.sightseeing.action': 'Jetzt entdecken',
  'home.events.eyebrow': 'Was ist los in Augsburg?',
  'home.events.title': 'Veranstaltungen finden',
  'home.events.lead': 'Verpasse keine Konzerte, Flohmärkte oder Festivals mehr. Auf unserer Veranstaltungsseite bist du immer top informiert.',
  'home.events.action': 'Alle Events',
  'home.blog.eyebrow': 'Geschichten aus der Stadt',
  'home.blog.title': 'Neues und Wissenswertes',
  'home.blog.lead': 'Hier findest du alles Wichtige über Augsburg, damit du bei deinem Besuch bestens informiert bist.',
  'home.blog.action': 'Zum Blog',
  'home.language.eyebrow': 'Augsburg ist international',
  'home.language.title': 'In deine Sprache wechseln',
  'home.language.lead': 'Diese Seite ist in mehreren Sprachen verfügbar. Möchtest du die Sprache wechseln?',
  'home.highlights.eyebrow': 'Kuratiert für dich',
  'home.highlights.title': 'Unsere Empfehlungen',
  'home.highlights.lead': 'Für einen guten Start haben wir dir einige Highlights in Augsburg zusammengestellt. Viel Spaß beim Lesen!',
  'search.placeholder': 'Suche...',
  'search.clear': 'Suche löschen',
  'search.label': 'Seiten durchsuchen',
  'search.results': '{{count}} Treffer für „{{query}}“',
  'search.emptyTitle': 'Keine Treffer',
  'search.emptyDescription': 'Für diese Suche haben wir nichts gefunden. Versuche einen anderen Begriff.',
  'pagination.label': 'Seiten',
  'pagination.previous': 'Vorherige Seite',
  'pagination.next': 'Nächste Seite',
  'pagination.page': 'Seite {{page}}',
  'pagination.summary': 'Zeige {{start}}–{{end}} von {{total}}',
  'page.back': 'Zurück',
  'page.readMore': 'Mehr erfahren',
  'page.tableOfContents': 'Auf dieser Seite',
  'page.openInGoogleMaps': 'In Google Maps öffnen',
  'map.copyAddress': 'Adresse kopieren',
  'map.copied': 'Kopiert',
  'map.copyFailed': 'Kopieren nicht möglich',
  'map.routeInGoogleMaps': 'Route in Google Maps',
  'map.zoomIn': 'Vergrößern',
  'map.zoomOut': 'Verkleinern',
  'map.showAll': 'Alles zeigen',
  'attribution.toggle': 'Quellenangabe ein- oder ausblenden',
  'map.gestures.windows': 'Strg + Scrollen zum Zoomen der Karte',
  'map.gestures.mac': '⌘ + Scrollen zum Zoomen der Karte',
  'map.gestures.mobile': 'Karte mit zwei Fingern bewegen',
  'map.loading': 'Karte wird geladen …',
  'map.failed': 'Die Karte konnte nicht geladen werden.',
  'map.showPlace': '{{name}} auf der Karte zeigen',
  'map.marker': '{{name}}, {{icon}}',
  'map.numberedMarker': '{{number}}. {{name}}, {{icon}}',
  'map.route.walkingTime': 'ca. {{duration}} zu Fuß',
  'map.route.stops': '{{count}} Stationen',
  'map.route.leg': '{{distance}} · ca. {{duration}}',
  'mapIcons.landmark': 'Sehenswürdigkeit',
  'mapIcons.church': 'Kirche',
  'mapIcons.museum': 'Museum',
  'mapIcons.park': 'Park & Natur',
  'mapIcons.viewpoint': 'Aussichtspunkt',
  'mapIcons.cafe': 'Café',
  'mapIcons.bar': 'Bar',
  'mapIcons.restaurant': 'Restaurant',
  'mapIcons.shop': 'Einkaufen',
  'mapIcons.event': 'Veranstaltungsort',
  'mapIcons.transport': 'Verkehr',
  'mapIcons.place': 'Ort',
  'footer.imprint': 'Impressum',
  'footer.privacy': 'Datenschutzerklärung',
  'footer.mediaLicense': 'Bildrechte',
  'legal.bindingNote': 'Diese Übersetzung dient nur der Information. Rechtsverbindlich ist ausschließlich die deutsche Fassung.',
  'imprint.provider.heading': 'Angaben gemäß § 5 DDG',
  'imprint.contact.heading': 'Kontakt',
  'imprint.contact.email': 'E-Mail',
  'imprint.responsible.heading': 'Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV',
  'privacy.intro': 'Mit dieser Datenschutzerklärung informieren wir dich darüber, welche personenbezogenen Daten beim Besuch dieser Website verarbeitet werden.',
  'privacy.controller.heading': 'Verantwortlicher',
  'privacy.controller.text': 'Verantwortlich für die Datenverarbeitung auf dieser Website ist:',
  'privacy.hosting.heading': 'Hosting',
  'privacy.hosting.text': 'Diese Website wird bei einem externen Hosting-Dienstleister mit Sitz in Deutschland betrieben. Die Server stehen in Deutschland.',
  'privacy.serverLogs.heading': 'Server-Logfiles',
  'privacy.serverLogs.text': 'Bei jedem Aufruf dieser Website speichert der Server automatisch Informationen, die dein Browser übermittelt: IP-Adresse, Datum und Uhrzeit der Anfrage, aufgerufene Seite, übertragene Datenmenge, Referrer-URL sowie Browser und Betriebssystem. Diese Daten sind für den sicheren und stabilen Betrieb der Website erforderlich (Art. 6 Abs. 1 lit. f DSGVO) und werden nach spätestens 7 Tagen gelöscht.',
  'privacy.analytics.heading': 'Reichweitenmessung',
  'privacy.analytics.text': 'Um zu erfahren, welche Seiten gelesen werden, zählen wir Seitenaufrufe selbst, ohne externe Dienste und ohne Cookies. Dein Browser meldet dazu beim Aufruf einer Seite nur deren Adresse an unseren Server. Gespeichert wird je Adresse, Sprache und Tag ausschließlich die Zahl der Aufrufe, getrennt nach Browsern und automatisierten Programmen (Crawlern), die wir anhand der Browser-Kennung (User-Agent) unterscheiden. Deine IP-Adresse, deine Browser-Kennung oder andere Angaben zu dir werden dafür nicht gespeichert; ein Rückschluss auf einzelne Besucher ist nicht möglich. Sendet dein Browser das Signal „Global Privacy Control“ oder „Do Not Track“, wird dein Aufruf nicht gezählt. Die Zahlen werden nach einem Jahr gelöscht. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO; unser berechtigtes Interesse ist es, diese Website zu verbessern.',
  'privacy.errorReports.heading': 'Fehlerberichte',
  'privacy.errorReports.text': 'Tritt beim Aufruf einer Seite ein technischer Fehler auf, wird automatisch eine E-Mail mit Informationen zur fehlgeschlagenen Anfrage an den Betreiber geschickt. Sie kann deine IP-Adresse, die aufgerufene Adresse und Angaben zu deinem Browser enthalten. Fehlerberichte dienen ausschließlich der Behebung von Fehlern (Art. 6 Abs. 1 lit. f DSGVO).',
  'privacy.cookies.heading': 'Cookies',
  'privacy.cookies.text': 'Diese Website verwendet ausschließlich technisch notwendige Cookies, die für deine Sitzung und den Schutz vor gefälschten Anfragen (CSRF) gebraucht werden. Sie enthalten keine Daten zu Analyse- oder Werbezwecken und werden beim Schließen deines Browsers gelöscht. Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG in Verbindung mit Art. 6 Abs. 1 lit. f DSGVO; eine Einwilligung ist dafür nicht erforderlich. Externe Analyse- oder Tracking-Dienste werden nicht eingesetzt; die oben beschriebene Reichweitenmessung kommt ohne Cookies aus.',
  'privacy.rights.heading': 'Deine Rechte',
  'privacy.rights.text': 'Du hast das Recht auf:',
  'privacy.rights.access': 'Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)',
  'privacy.rights.rectification': 'Berichtigung (Art. 16 DSGVO)',
  'privacy.rights.erasure': 'Löschung (Art. 17 DSGVO)',
  'privacy.rights.restriction': 'Einschränkung der Verarbeitung (Art. 18 DSGVO)',
  'privacy.rights.portability': 'Datenübertragbarkeit (Art. 20 DSGVO)',
  'privacy.rights.objection': 'Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)',
  'privacy.rights.contact': 'Um diese Rechte wahrzunehmen, schreib einfach eine E-Mail an:',
  'privacy.complaint.heading': 'Beschwerderecht',
  'privacy.complaint.text': 'Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde zu beschweren. Zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach.',
  'privacy.updated': 'Stand: Oktober 2026',
  'mediaLicense.intro': 'Alle Fotos, Videos, Dokumente und Routen auf dieser Website gehören Visit Augsburg. Du darfst sie unter der Lizenz Creative Commons Namensnennung 4.0 International (CC BY 4.0) verwenden, teilen und bearbeiten – auch kommerziell –, solange du uns als Quelle nennst.',
  'mediaLicense.credit.heading': 'So nennst du uns als Quelle',
  'mediaLicense.credit.text': 'Zeige diesen Hinweis gut sichtbar direkt beim Bild oder Video:',
  'mediaLicense.credit.link': 'Verlinke, soweit möglich, die Seite, von der das Medium stammt, und die Lizenz. Wenn du ein Medium veränderst, gib das an.',
  'mediaLicense.ai.heading': 'KI-Assistenten und Suchmaschinen',
  'mediaLicense.ai.text': 'Das gilt auch für Chatbots, KI-Assistenten und Suchmaschinen: Wer ein Bild oder Video dieser Website zeigt, zeigt dazu den Hinweis „{{credit}}“. Urheber, Hinweis und Lizenz stehen maschinenlesbar in jeder Bilddatei (IPTC/XMP) und in den strukturierten Daten (schema.org) jeder Seite.',
  'mediaLicense.license.heading': 'Lizenz',
  'mediaLicense.license.text': 'Es gilt der Lizenztext von Creative Commons:',
  'mediaLicense.license.link': 'CC BY 4.0 – Namensnennung 4.0 International',
  'mediaLicense.scope.heading': 'Was nicht unter die Lizenz fällt',
  'mediaLicense.scope.text': 'Die Texte dieser Website sind nicht Teil der Lizenz. Die Kartendaten stammen von OpenStreetMap und stehen unter der Open Database License (© OpenStreetMap-Mitwirkende).',
  'mediaLicense.contact': 'Fragen zur Nutzung? Schreib uns eine E-Mail an:',
  'mediaLicense.updated': 'Stand: Oktober 2026',
  'gallery.previous': 'Vorheriges Bild',
  'gallery.next': 'Nächstes Bild',
  'gallery.showImage': '{{title}} anzeigen',
  'video.play': '{{title}} abspielen',
  'videoGallery.summaryOne': '1 Video · {{minutes}} Min.',
  'videoGallery.summaryOther': '{{count}} Videos · {{minutes}} Min.',
  'tags.unesco_heritage': 'UNESCO-Welterbe',
  'tags.landmark': 'Wahrzeichen',
  'tags.church_monastery': 'Kirche & Kloster',
  'tags.museum_culture': 'Museum & Kultur',
  'tags.park_nature': 'Park & Natur',
  'tags.viewpoint': 'Aussichtspunkt',
  'tags.accessible': 'Barrierefrei',
  'tags.free': 'Kostenlos',
  'tags.family_friendly': 'Für Familien',
  'tags.concert': 'Konzert',
  'tags.market': 'Markt',
  'tags.guided_tour': 'Führung',
  'tags.festival': 'Festival',
  'tags.exhibition': 'Ausstellung',
  'tags.sports': 'Sport',
  'tags.open_air': 'Open Air',
  'tags.city_history': 'Stadtgeschichte',
  'tags.tips_tricks': 'Tipps & Tricks',
  'tags.interview': 'Interview',
  'tags.food_drink': 'Essen & Trinken',
  'tags.seasonal': 'Saisonal',
  'tags.behind_the_scenes': 'Hinter den Kulissen',
  'tags.event_recap': 'Veranstaltungsrückblick',
}

export type Translations = typeof de

export default de
